<div>
    <p-calendar [(ngModel)]="rangeDate.dateFrom" dateFormat="dd.mm.yy" placeholder="od"></p-calendar>
    <p-calendar [(ngModel)]="rangeDate.dateTo" dateFormat="dd.mm.yy" placeholder="do"></p-calendar>
    <button pButton type="button" label="Pobierz" (click)="getReport()"></button>

</div>